"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getters = void 0;
var getters = {
  language: function language(state) {
    return state.language;
  },
  breadcrumbList: function breadcrumbList(state) {
    return state.breadcrumbList;
  },
  loading: function loading(state) {
    return state.loading;
  },
  isDarkTheme: function isDarkTheme(state) {
    return state.isDarkTheme;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  isOrderFullscreen: function isOrderFullscreen(state) {
    return state.isOrderFullscreen;
  },
  isMobile: function isMobile(state) {
    return state.isMobile;
  },
  mainContainerHeight: function mainContainerHeight(state) {
    return state.mainContainerHeight;
  },
  dashboardVehicles: function dashboardVehicles(state) {
    return state.dashboardVehicles;
  },
  isTab: function isTab(state) {
    return state.isTab;
  },
  drivers: function drivers(state) {
    return state.drivers;
  },
  projectCodes: function projectCodes(state) {
    return state.projectCodes;
  },
  customers: function customers(state) {
    return state.customers;
  },
  trucks: function trucks(state) {
    return state.trucks;
  },
  socketId: function socketId(state) {
    return state.socketId;
  }
};
exports.getters = getters;